var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"color":"#F0EBE1"}},[_c('center',[_c('h3',[_vm._v("电影著作年份直方图")])]),_c('el-scrollbar',[_c('svg',{attrs:{"id":"hist","height":"50vh","width":"100vw"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }